import React, { useState } from "react";
import * as styles from "./index.module.scss";

import Helmet from "react-helmet";

import Footer from "@components/footer";
import Header from "@components/header";
import { useI18n } from "@src/i18n";

import { Button, Col, Collapse, Row, Space } from "antd";

import phoneImg from "@src/images/price/Button.png";
import phoneImgEn from "@src/images/price/Button-en.png";
import pcImg from "@src/images/price/飞书20210915-180123.png";
import pcImgEn from "@src/images/price/飞书20210915-180123-en.png";

import { navigate } from "gatsby";

const handleRegister = (event) => {
  event.preventDefault();
  navigate("/register/");
};

const colors = ["#F9B145", "#0075FF", "#181F32", "#C18F34"];

const SuccessIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 26 19"
    //   fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99607 18.5605L0.841796 10.4551C0.613932 10.2272 0.5 9.93422 0.5 9.57615C0.5 9.21807 0.613932 8.92511 0.841796 8.69724L2.64843 6.93943C2.8763 6.67902 3.16113 6.54883 3.50292 6.54883C3.84472 6.54883 4.14582 6.67902 4.40624 6.93943L9.87498 12.4082L21.5937 0.689452C21.8541 0.429036 22.1552 0.298828 22.497 0.298828C22.8388 0.298828 23.1236 0.429036 23.3515 0.689452L25.1581 2.44726C25.386 2.67512 25.4999 2.96809 25.4999 3.32616C25.4999 3.68424 25.386 3.9772 25.1581 4.20507L10.7539 18.5605C10.526 18.8209 10.233 18.9511 9.87498 18.9511C9.5169 18.9511 9.22394 18.8209 8.99607 18.5605Z"
      fill="currentColor"
    />
  </svg>
);

const OkIcon = ({ style }) => {
  return (
    <span
      style={{
        ...style,
      }}
      className={styles.okIconStyle}
    >
      <SuccessIcon />
    </span>
  );
};

const EssentialsIcon = () => (
  <OkIcon style={{ backgroundColor: "#FEF3E3", color: "#F9B145" }} />
);
const StandardIcon = () => (
  <OkIcon style={{ backgroundColor: "#D9EAFF", color: "#0075FF" }} />
);
const PremiumIcon = () => (
  <OkIcon style={{ backgroundColor: "#DCDDE0", color: "#181F32" }} />
);
const ExclusiveIcon = () => (
  <OkIcon style={{ backgroundColor: "#F6EEE1", color: "#C18F34" }} />
);

const Icons = [EssentialsIcon, StandardIcon, PremiumIcon, ExclusiveIcon];

const PriceIntroPage = () => {
  const { locale, t } = useI18n();
  const pricingImage = locale === "en-US" ? pcImgEn : pcImg;
  const pricingPhoneImage = locale === "en-US" ? phoneImgEn : phoneImg;
  const [selectIndex, setSelectIndex] = useState(0);
  const availableData = t("pricingPage.featureGroups").map((item) => ({
    ...item,
    aviabileItems: item.items.map((itemName) => ({
      itemName,
      aviable: [1, 1, 1, 1],
    })),
  }));
  const smallPriceData = [
    {
      price: 29,
      name: t("pricingPage.sellers.0"),
      EnglishName: "Shoprise Essentials",
      details: [t("pricingPage.transactionRates.0"), t("pricingPage.support.0"), t("pricingPage.basicFeature")],
    },
    {
      price: 79,
      name: t("pricingPage.sellers.1"),
      EnglishName: "Shoprise Standard",
      details: [t("pricingPage.transactionRates.1"), t("pricingPage.support.1"), t("pricingPage.basicFeature")],
    },
    {
      price: 229,
      name: t("pricingPage.sellers.2"),
      EnglishName: "Shoprise Premium",
      details: [
        t("pricingPage.transactionRates.2"),
        t("pricingPage.support.1"),
        t("pricingPage.support.2"),
        t("pricingPage.basicFeature"),
      ],
    },
    {
      price: t("pricingPage.quote"),
      name: `${t("pricingPage.custom")}${t("pricingPage.privateDeploy")}`,
      specialName: [t("pricingPage.custom"), t("pricingPage.privateDeploy")],
      EnglishName: "Shoprise Essentials",
      details: [t("pricingPage.support.1"), t("pricingPage.support.2"), t("pricingPage.basicFeature")],
      special: true,
    },
  ];

  return (
    <div className={styles.priceIntroPage}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("pricingPage.title")}</title>
      </Helmet>
      <Header />
      <div className={styles.banner}>
        <picture>
          <source srcSet={pricingImage} media="(min-width:760px)" />
          <source srcSet={pricingPhoneImage} media="(max-width:760px)" />
          <img src={pricingImage} alt="pic" />
        </picture>

          <Button
            className={styles.primaryButton}
            shape="round"
            onClick={handleRegister}
          >
            {t("pricingPage.cta")}
          </Button>
      </div>

      <Row>
        <Col xs={0} sm={0} md={24}>
          <div className={styles.tableContainer}>
            <table>
              <thead>
                <tr>
                  <th>
                    Shoprise <br />
                    {t("pricingPage.featureDetails")}
                  </th>
                  <th>
                    {t("pricingPage.plans.0")}
                    <br />
                    <small>Shoprise Essentials</small>
                  </th>
                  <th>
                    {t("pricingPage.plans.1")}
                    <br />
                    <small>Shoprise Standard</small>
                  </th>
                  <th>
                    {t("pricingPage.plans.2")}
                    <br />
                    <small>Shoprise Premium</small>
                  </th>
                  <th>
                    {t("pricingPage.plans.3")}
                    <br />
                    <small>Shoprise Exclusive</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t("pricingPage.monthlyRent")}</td>
                  <td style={{ color: "#F9B145" }}>
                    <small style={{ fontSize: "15px" }}>$</small>29{" "}
                    <small style={{ fontSize: "16px", color: "#5A7184" }}>
                      {t("pricingPage.month")}
                    </small>
                  </td>
                  <td style={{ color: "#0075FF" }}>
                    <small style={{ fontSize: "15px" }}>$</small>79{" "}
                    <small style={{ fontSize: "16px", color: "#5A7184" }}>
                      {t("pricingPage.month")}
                    </small>
                  </td>
                  <td style={{ color: "#181F32" }}>
                    <small style={{ fontSize: "15px" }}>$</small>229{" "}
                    <small style={{ fontSize: "16px", color: "#5A7184" }}>
                      {t("pricingPage.month")}
                    </small>
                  </td>
                  <td rowSpan={3}>
                    {t("pricingPage.quote")}
                    <div
                      style={{
                        fontSize: "18px",
                        lineHeight: "30px",
                        fontWeight: "normal",
                      }}
                    >
                      {t("pricingPage.custom")}
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        lineHeight: "30px",
                        fontWeight: "normal",
                      }}
                    >
                      {t("pricingPage.privateDeploy")}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{t("pricingPage.transactionFee")}</td>
                  <td>{t("pricingPage.transactionRates.0")}</td>
                  <td>{t("pricingPage.transactionRates.1")}</td>
                  <td>{t("pricingPage.transactionRates.2")}</td>
                  {/* <td>无界式定制</td> */}
                </tr>
                <tr>
                  <td>{t("pricingPage.targetSeller")}</td>
                  <td>{t("pricingPage.sellers.0")}</td>
                  <td>{t("pricingPage.sellers.1")}</td>
                  <td>{t("pricingPage.sellers.2")}</td>
                  {/* <td>私人部署</td> */}
                </tr>
                <tr>
                  <td>{t("pricingPage.serviceSupport")}</td>
                  <td>{t("pricingPage.support.0")}</td>
                  <td>{t("pricingPage.support.1")}</td>
                  <td>
                    {t("pricingPage.support.1")} <br />
                    {t("pricingPage.support.2")}
                  </td>
                  <td>
                    {t("pricingPage.support.1")} <br />
                    {t("pricingPage.support.2")}
                  </td>
                </tr>
                <tr>
                  <td>{t("pricingPage.basicFeature")}</td>
                  <td>
                    <EssentialsIcon />
                  </td>
                  <td>
                    <StandardIcon />
                  </td>
                  <td>
                    <PremiumIcon />
                  </td>
                  <td>
                    <ExclusiveIcon />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={24} sm={24} md={0}>
          <div className={styles.smallPriceIntro}>
            <div className={styles.priceIntroHeader}>
              <div
                className={styles.smallBtn}
                style={selectIndex === 0 ? { backgroundColor: colors[0] } : {}}
                onClick={() => {
                  setSelectIndex(0);
                  console.log("点击了");
                }}
              >
                {t("pricingPage.plans.0")}
              </div>
              <div
                className={styles.smallBtn}
                style={selectIndex === 1 ? { backgroundColor: colors[1] } : {}}
                onClick={() => {
                  setSelectIndex(1);
                }}
              >
                {t("pricingPage.plans.1")}
              </div>
              <div
                className={styles.smallBtn}
                style={selectIndex === 2 ? { backgroundColor: colors[2] } : {}}
                onClick={() => {
                  setSelectIndex(2);
                }}
              >
                {t("pricingPage.plans.2")}
              </div>
              <div
                className={styles.smallBtn}
                style={
                  selectIndex === 3
                    ? {
                        background:
                          "linear-gradient(90deg, #EDD3A2 5.77%, #E1C188 100%)",
                        color: "#181F32",
                      }
                    : {}
                }
                onClick={() => {
                  setSelectIndex(3);
                }}
              >
                {t("pricingPage.plans.3")}
              </div>
            </div>
            <div className={styles.priceIntroContent}>
              <div className={styles.contentTop}>
                <div
                  className={styles.topPrice}
                  style={
                    smallPriceData[selectIndex].special
                      ? { color: "#181F32" }
                      : { color: colors[selectIndex] }
                  }
                >
                  {typeof smallPriceData[selectIndex].price === "number" ? (
                    <small>$</small>
                  ) : (
                    ""
                  )}
                  {smallPriceData[selectIndex].price}
                  {typeof smallPriceData[selectIndex].price === "number" ? (
                    <small style={{ marginLeft: "10px", color: "#5A7184" }}>
                      {t("pricingPage.month")}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.topEnglishName}>
                  {/* Shoprise Essentials */}
                  {smallPriceData[selectIndex].EnglishName}
                </div>
                <div className={styles.topAvaiableUser}>
                  {smallPriceData[selectIndex].specialName
                    ? smallPriceData[selectIndex].specialName.map((item) => (
                        <div key={item} className={styles.specialNameItem}>
                          {item}
                        </div>
                      ))
                    : smallPriceData[selectIndex].name}
                  {/* {smallPriceData[selectIndex].name} */}
                </div>
              </div>
              <div className={styles.contentBottom}>
                {smallPriceData[selectIndex].details.map((item) => {
                  const Icon = Icons[selectIndex];
                  return (
                    <div className={styles.bottomItem} key={item}>
                      <Space size="small">
                        <Icon />
                        {item}
                      </Space>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={0} sm={0} md={24}>
          <div className={styles.priceDetail}>
            <Collapse
              defaultActiveKey={["0", "1", "2", "3", "4", "5", "6"]}
              expandIconPosition="right"
              ghost
              bordered="false"
            >
              {availableData.map((item, index) => {
                return (
                  <Collapse.Panel header={item.title} key={index}>
                    {item.aviabileItems.map((item) => {
                      return (
                        <Row key={item.itemName} className={styles.rowStyle}>
                          <Col flex={"20%"}>{item.itemName}</Col>
                          {item.aviable.map((item, index) => {
                            const Icon = Icons[index];
                            return (
                              <Col
                                flex={1}
                                key={index}
                                style={{ textAlign: "center" }}
                              >
                                {item ? <Icon /> : ""}
                              </Col>
                            );
                          })}
                        </Row>
                      );
                    })}
                  </Collapse.Panel>
                );
              })}
            </Collapse>
          </div>
        </Col>
        <Col xs={24} sm={24} md={0}>
          <div className={styles.smallPriceDetail}>
            <Collapse expandIconPosition="right" ghost>
              {availableData.map((item) => {
                const Icon = Icons[selectIndex];

                return (
                  <Collapse.Panel header={item.title} key={item.title}>
                    {item.aviabileItems.map((secItem) => {
                      return (
                        <div
                          className={styles.pannelInner}
                          key={secItem.itemName}
                        >
                          <div>{secItem.itemName}</div>
                          {secItem.aviable[selectIndex] ? <Icon /> : ""}
                        </div>
                      );
                    })}
                  </Collapse.Panel>
                );
              })}
            </Collapse>
          </div>
        </Col>
      </Row>

      <Footer />
    </div>
  );
};

export default PriceIntroPage;
